import { useHingeHealthSecurityContext } from '@hinge-health/react-component-library';
import { useClient } from '@splitsoftware/splitio-react';
import { RouteDetails } from '../routes';

export const useSplitEnabledRoutes = (
  routes: RouteDetails[],
): RouteDetails[] => {
  const splitClient = useClient();
  const { hingeHealthAuthState } = useHingeHealthSecurityContext();
  const uid = hingeHealthAuthState?.accessToken?.claims?.uid?.toString() ?? '';

  return routes.filter(
    route =>
      !route.splitFlag ||
      splitClient?.getTreatment(route.splitFlag, { uid }) === 'on',
  );
};
